"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemContentsDiffer = void 0;
const ItemContentsEqual_1 = require("./ItemContentsEqual");
function ItemContentsDiffer(item1, item2, excludeContentKeys = []) {
    return !(0, ItemContentsEqual_1.ItemContentsEqual)(item1.content, item2.content, [...item1.contentKeysToIgnoreWhenCheckingEquality(), ...excludeContentKeys], item1.appDataContentKeysToIgnoreWhenCheckingEquality());
}
exports.ItemContentsDiffer = ItemContentsDiffer;
